import {
  AuthApiClient,
  BookingApiClient,
  CreditApiClient,
  EventsApiClient,
  InviteApiClient,
  MapApiClient,
  OrgApiClient,
  ProfileApiClient,
  PublicApiClient,
  QuizApiClient,
  ReferralApiClient,
  TicketApiClient
} from "@garther/api-client";

import { AppCfg } from "@/shared/config/app";

export { ApiError } from "@garther/api-client";

export const authApiClient = new AuthApiClient({
  baseURL: AppCfg.apiBaseUrl
});

const defaultConfig = {
  baseURL: AppCfg.apiBaseUrl,
  getToken: authApiClient.getToken
};

export const orgApiClient = new OrgApiClient(defaultConfig);
export const eventsApiClient = new EventsApiClient(defaultConfig);
export const ticketApiClient = new TicketApiClient(defaultConfig);

export const profileApiClient = new ProfileApiClient(defaultConfig);
export const creditApiClient = new CreditApiClient(defaultConfig);
export const referralApiClient = new ReferralApiClient(defaultConfig);
export const quizApiClient = new QuizApiClient(defaultConfig);

export const bookingApiClient = new BookingApiClient(defaultConfig);
export const inviteApiClient = new InviteApiClient(defaultConfig);

export const mapApiClient = new MapApiClient(defaultConfig);
export const publicApiClient = new PublicApiClient(defaultConfig);
